import { render } from "./ChatAdminMessageHeader.vue?vue&type=template&id=624c3e56&scoped=true"
const script = {}

import "./ChatAdminMessageHeader.vue?vue&type=style&index=0&id=624c3e56&lang=scss&scoped=true"

import exportComponent from "/var/www/briskly/brskl/products/business/app.prod.new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-624c3e56"]])

export default __exports__